export enum FieldTypesE { // eslint-disable-line
  TEXT = 0, // eslint-disable-line
  TEXT_MULTILINES, // eslint-disable-line
  CHECKBOX, // eslint-disable-line
  NUMBER, // eslint-disable-line
  DATE, // eslint-disable-line
}
